import { GODIA_LOYALTY, OFFER_FIRST_TYPE } from "@constants";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { produce } from "immer";
import { v4 as uuid } from "uuid";
import { snapshot } from "valtio";

import { fillMiddlwareOrder, getDiscountRateValue } from "@helpers/mwHelpers";

import { getDiscountRate } from "@components/OrderTaking/Helpers";
import {
    convertSalesModeValue,
    reOrderItemsByStepOrderAndParentUuid,
} from "@components/OrderTaking/Helpers/Commonfunction";
import { syncStore } from "@components/Synchronization/store";

import { kioskStore } from "@pages/Kiosk/store";

interface MiddlewareOrderPayload {
    selectedSaleModeValue: string;
    selectedInformationMode: string;
    selectedRegulationModeValue: string;
    selectedAuthMode: string;
    chosenInformationMode: {
        type: string;
        data: {
            infoModeUuId: string;
            value: string;
        };
    };
    paymentModes: PaymentModesType;
    phoneNumber: string;
    amountRatio?: number;
}

const {
    project: { fidelityType },
} = snapshot(kioskStore);

export const setMiddleWareOrderAsync = createAsyncThunk(
    "middleWareOrderSlice/setMiddleWareOrderAsync",
    async (payload: MiddlewareOrderPayload, { getState }) => {
        const { machineIpAddress } = snapshot(syncStore);
        console.log("store:", { machineIpAddress });
        // eslint-disable-next-line
        const state = getState() as any;
        const data: LineDataType[] = [];
        const {
            order,
            usedGifts,
            userRewards: { rewards },
        } = state.orderSlice;
        const loyaltyRewards = rewards;
        const {
            selectedSaleModeValue,
            selectedAuthMode,
            chosenInformationMode,
            paymentModes,
            phoneNumber,
        } = payload;
        const lineDiscount = {
            discountMontant: 0,
            discountTaux: 0,
            libelle: "",
        };
        console.log(
            `setMiddlwareOrder --- order before structure modification : ${JSON.stringify(
                order
            )}`
        );

        const processedOrder: ProcessedOrderType = {
            orderUuid: uuid(),
            codeManager: 0,
            nomManager: "",
            codeVendeur: 0,
            nomOVendeur: "",
            nbClient: "",
            orderOrigine: "KIOSK",
            ipOrigine: machineIpAddress,
            numCommande: "",
            sourceOrderOrigine: "",
            sourceOrderNumber: 0,
            destinationOrderOrigine: "",
            destinationTicketNumber: 0,
            horodatage: Date.now(),
            tag: "",
            dateFiscale: Date.now(),
            OrderId: 0,
            remiseGlobale: {},
            salesMode: convertSalesModeValue(selectedSaleModeValue),
            totalttc: 0,
            deviseCode: "euro",
            deviseTaux: 0,
            deviseLibelle: "euro",
            lines: [],
            promo: { type: "cesar", usedCodes: [] },
            loyalty_payment: 0,
            reglements: paymentModes,
            complement: {
                modeInfo: chosenInformationMode,
                modeAuth: { type: selectedAuthMode, data: "" },
            },
            clientPhoneNumber: phoneNumber,
        };

        //! to verify
        let discountRate = 0;
        let isOrderPromo = false;
        const promo: PromoType = {
            type: fidelityType === GODIA_LOYALTY ? "godia" : "cesar",
            usedCodes: [],
        };
        if (usedGifts.length > 0) {
            const totalOrderNet = order.orderItems.reduce(
                // eslint-disable-next-line
                (a: any, c: any) => a + c.quantity * c.price,
                0
            );
            const promoProduct = (order as orderType).orderItems.filter(
                // eslint-disable-next-line
                (product: any) => product.isPromo === true
            )[0];
            const discountItems = getDiscountRate(
                totalOrderNet,
                usedGifts[0].discountType,
                usedGifts[0].discountValue,
                promoProduct
            );
            discountRate = discountItems.discountRate;
            isOrderPromo = discountItems.isOrderPromo;
            promo.usedCodes = [{ ...usedGifts[0], discountRate }];
        }

        console.log("paymentModes", paymentModes);

        let linesTotalPrice = 0;
        order.orderItems // eslint-disable-next-line
            .reduce((prev: any, currProd: any) => {
                if (currProd.offer.isEnabled && currProd.quantity > 1) {
                    const separatedProducts = [];

                    for (let i = 0; i < currProd.quantity; i++) {
                        const itemData = {
                            ...currProd,
                            quantity: 1,
                            iuudOrder: i === 0 ? currProd.iuudOrder : uuid(),
                        };
                        separatedProducts.push(itemData);
                    }
                    return [...prev, ...separatedProducts];
                }
                return [...prev, currProd];
            }, []) // eslint-disable-next-line
            .forEach((item: any) => {
                if (Object.keys(item?.shopCart).length === 0) {
                    processedOrder.lines.push({
                        lineUuid: item.iuudOrder,
                        isReward: item.isReward ?? false,
                        orderUuid: processedOrder.orderUuid,
                        horodatage: item.date,
                        codeManager: processedOrder.codeManager,
                        nomManager: processedOrder.nomManager,
                        codeVendeur: processedOrder.codeVendeur,
                        nomVendeur: processedOrder.nomOVendeur,
                        reference: item.reference,
                        itemUuid: item.iuud,
                        typeLigne: "ARTICLE",
                        designation: item.designation,
                        prix: item.price,
                        qte: item.quantity,
                        poids: 1,
                        unite: item.unity,
                        libFamille: item.categoryTitle,
                        libSousFamille: item.subcategoryTitle,
                        numFamille: item.parent,
                        numSousFamille: 0,
                        libelleTVA: "",
                        numTVA: 0,
                        tauxTVA: item.tva !== undefined ? item.tva : 0,
                        ipOrigine: machineIpAddress,
                        orderOrigine: "",
                        lineDiscount: lineDiscount,
                        montantTotalTTC:
                            item.price * item.quantity -
                            item.price *
                                item.quantity *
                                (lineDiscount.discountTaux / 100),
                        montantTotalHT: 0,
                        tag: "",
                        pointFid: item.fidelity,
                        ModifierUuid: "",
                        parentLineUuid: "",
                        stepTitle: item.stepTitle ? item.stepTitle : "",
                        selectedOptions: item.selectedOptions,
                        selectedOptionsUuid: item.selectedOptionsUuid,
                        selectedIndexOptions: item.selectedIndexOptions,
                        comment:
                            item?.comment !== undefined ? item?.comment : "",
                        isSubProduct: item.isSubProduct,
                        isOfferParent: item.isOfferParent,
                        isOfferChild: item.isOfferChild,
                        discountRate: getDiscountRateValue(
                            item,
                            discountRate,
                            isOrderPromo
                        ),
                        isPromo: item.isPromo ?? false,
                    });
                } else {
                    const orderInfo: OrderInfoType = {
                        orderUuid: processedOrder.orderUuid,
                        codeManager: processedOrder.codeManager,
                        nomManager: processedOrder.nomManager,
                        codeVendeur: processedOrder.codeVendeur,
                        nomVendeur: processedOrder.nomOVendeur,
                    };

                    if (
                        item.isOfferParent &&
                        item.offer.type === OFFER_FIRST_TYPE
                    ) {
                        // eslint-disable-next-line
                        item = produce(item, (draft: any) => {
                            if (draft.isOfferParent) {
                                // eslint-disable-next-line
                                const shopCartValues: any = Object.values(
                                    draft.shopCart
                                );
                                draft.price = 0;
                                const compositions =
                                    shopCartValues[0]?.compositions;

                                if (compositions) {
                                    Object.keys(compositions).forEach((key) => {
                                        const subItem = compositions[key];
                                        if (subItem?.price > 0) {
                                            draft.price += subItem.price;
                                            subItem.price = 0;
                                        }
                                    });
                                }
                            }
                        });
                    }
                    processedOrder.lines.push({
                        lineUuid: item.iuudOrder,
                        isReward: item.isReward ?? false,
                        orderUuid: processedOrder.orderUuid,
                        horodatage: item.date,
                        codeManager: processedOrder.codeManager,
                        nomManager: processedOrder.nomManager,
                        codeVendeur: processedOrder.codeVendeur,
                        nomVendeur: processedOrder.nomOVendeur,
                        reference: item.reference,
                        itemUuid: item.iuud,
                        typeLigne:
                            item.haveWorkflow && !item.isOfferParent
                                ? "MENU"
                                : "Article",
                        designation: item.designation,
                        prix:
                            item.offer.type === OFFER_FIRST_TYPE &&
                            (item.isOfferParent || item.isOfferChild)
                                ? item.price
                                : item.defaultPrice,

                        qte: item.quantity,
                        poids: 1,
                        unite: item.unity,
                        libFamille: item.categoryTitle,
                        libSousFamille: item.subcategoryTitle,
                        numFamille: item.parent,
                        numSousFamille: 0,
                        libelleTVA: "",
                        numTVA: 0,
                        tauxTVA: item.tva !== undefined ? item.tva : 0,
                        ipOrigine: machineIpAddress,
                        orderOrigine: "",
                        lineDiscount: lineDiscount,
                        montantTotalTTC:
                            item.defaultPrice * item.quantity -
                            item.defaultPrice *
                                item.quantity *
                                (lineDiscount.discountTaux / 100),
                        montantTotalHT: 0,
                        tag: "",
                        pointFid: item.fidelity,
                        ModifierUuid: "",
                        parentLineUuid: "",
                        stepTitle: item.stepTitle ? item.stepTitle : "",
                        selectedOptions: item.selectedOptions,
                        selectedOptionsUuid: item.selectedOptionsUuid,
                        selectedIndexOptions: item.selectedIndexOptions,
                        comment:
                            item?.comment !== undefined ? item?.comment : "",
                        isSubProduct: item.isSubProduct,
                        discountRate: getDiscountRateValue(
                            item,
                            discountRate,
                            isOrderPromo
                        ),
                        isPromo: item.isPromo ?? false,
                        isOfferParent: item.isOfferParent,
                        isOfferChild: item.isOfferChild,
                    });

                    fillMiddlwareOrder(
                        item.shopCart,
                        item.iuudOrder,
                        orderInfo,
                        discountRate,
                        isOrderPromo,
                        lineDiscount,
                        data
                    );

                    processedOrder.lines = [...processedOrder.lines, ...data];
                }
            });
        const nesSetLines: LineDataType[] = Array.from(
            new Set(processedOrder.lines)
        );
        const newLines = reOrderItemsByStepOrderAndParentUuid(
            nesSetLines.sort((a: LineDataType, b: LineDataType) => {
                return a.stepRank - b.stepRank;
            })
        );

        newLines.forEach((line) => {
            let qte = line.qte;
            const itemParent = newLines.find(
                (elm) => elm.lineUuid === line.parentLineUuid
            );
            if (itemParent) {
                qte *= itemParent.qte;
            }
            linesTotalPrice += line.prix * qte;
        });
        linesTotalPrice = Math.round(linesTotalPrice * 100) / 100;

        if (linesTotalPrice != order.totalPrice) {
            console.error(
                `ERRRROORR: Total price different of total order lines price with totalPrice: ${order.totalPrice} and linesTotalPrice: ${linesTotalPrice}`
            );
        }
        console.log(
            `setMiddlwareOrder --- order lines after structure modification : ${JSON.stringify(
                newLines
            )}`
        );

        processedOrder.lines = newLines;

        const finalRewardList: finalRewardListType[] = [];
        let totalRewardsPoints = 0;
        const rewardsRef = processedOrder.lines
            .filter((line: LineDataType) => line.isReward)
            .map((line: LineDataType) => line.reference);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        loyaltyRewards.forEach((item: any) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const rewardList = item.rewardList.filter((reward: any) =>
                rewardsRef.includes(reward.reference)
            );
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            rewardList.forEach((reward: any) => {
                totalRewardsPoints =
                    totalRewardsPoints + Number(item.loyalty_points);
                finalRewardList.push({
                    program_id: item.program_id,
                    reward_name: item.reward_name,
                    reward_item_reference: reward.reference,
                    loyalty_points: item.loyalty_points,
                });
            });
        });
        processedOrder.rewards = [...finalRewardList];
        processedOrder.loyalty_payment = totalRewardsPoints;
        processedOrder.promo = promo;

        processedOrder.totalttc = order.totalPrice;
        return processedOrder;
    }
);
